import React, { useEffect, useState, useContext } from "react";
import { ProjectContext } from "../../App";
import { Link, useParams } from "react-router-dom";
import api from "../../api/axiosConfig";
import { format } from "date-fns";
import { IoMdClose } from "react-icons/io";
import { TbArrowBackUp } from "react-icons/tb";
import { FaChevronDown } from "react-icons/fa";

const RevisionTable = () => {
  const { templateName, estimateId, phaseId } = useParams();
  const Template = templateName.charAt(0).toUpperCase() + templateName.slice(1);
  const [selectedRevId, setSelectedRevId] = useState([]);
  const [deleteRevisionDial, setDeleteRevisionDial] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const { dialBoxopen, isNavBarOpen } = useContext(ProjectContext);
  const [revision, setRevision] = useState([]);
  const [revisionTasks, setRevisionTasks] = useState([]);
  const [error, setError] = useState(null); // To handle errors
  const [loading, setLoading] = useState(true); // To show loading state
  const [revisedTemplateId, setRevisedTemplateId] = useState("");
  const [revisedNo, setRevisedeNo] = useState("");
  const [revTemplateName, setRevTemplateName] = useState("");
  const codeDescriptions = {
    MD: "Member Design",
    CD: "Connection Design",
    SD: "Steel Detailing",
  };
  const fetchTaskData = async () => {
    try {
      const revisionResponse = await api.get(
        `/api/estimatesrevision/${estimateId}/${phaseId}`
      );
      const revisionTasksResponse = await api.get(
        `/api/estimate/revisedtasks/${revisedTemplateId}`
      );
      setRevision(revisionResponse.data);
      setRevisionTasks(revisionTasksResponse.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchTaskData();
  }, [estimateId, phaseId, revisedTemplateId]);

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }
  const groupedTasks = revisionTasks.reduce((groups, task) => {
    const { code } = task;
    if (!groups[code]) {
      groups[code] = []; // Initialize the group for this code
    }
    groups[code].push(task); // Add the task to the group
    return groups;
  }, {});

  const toHHMM = (totalHours) => {
    const hours = Math.floor(totalHours);
    const minutes = Math.round((totalHours - hours) * 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  const handleDeleteRevision = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // Add phaseId to the selectedPhaseId array
      setSelectedRevId((prev) => [...prev, id]);
    } else {
      // Remove phaseId from the selectedPhaseId array
      setSelectedRevId((prev) => prev.filter((id) => id !== id));
    }
  };
  const handleDeleteConfirm = async () => {
    if (isCheckboxChecked) {
      try {
        await api.delete(`/api/estimaterevision`, { data: { selectedRevId } }); // Send phaseIds in the request body
        setSelectedRevId([]);
        setDeleteRevisionDial(false);
        setIsCheckboxChecked(false);
        fetchTaskData();
      } catch (error) {
        console.error("Failed to delete revision:", error); // Log the error for debugging
        setError(error); // Display the error message to the user
      }
    } else {
      alert("Please check the checkbox to confirm deletion."); // Alert if no checkbox is checked
    }
  };
  const grandTotalHours = Object.values(groupedTasks)
    .flat()
    .reduce((sum, task) => sum + parseFloat(task.planned_hours || 0), 0);
  const grandTotal = toHHMM(grandTotalHours);

  return (
    <div className="revision-main-container">
      <Link to={`/estimate/phases/${estimateId}/${phaseId}`}>
        <IoMdClose className="revise-task-close" />
      </Link>
      <div
        className={
          isNavBarOpen
            ? "revision-details-container"
            : "revision-details-container-close"
        }
      >
        <p style={{ marginBottom: "5px", marginRight: "20px" }}>
          Estimate No : {revision.estimate.estimationno}
        </p>
        <p style={{ marginBottom: "5px", marginRight: "20px" }}>
          Project Name : {revision.estimate.projectname}
        </p>
        <p style={{ marginBottom: "5px", marginRight: "20px" }}>
          Phase No : {revision.estimate.phase_number}
        </p>
        <p style={{ marginBottom: "5px", marginRight: "20px" }}>
          Phase title : {revision.estimate.phase_name}
        </p>
        {revisedNo && revisedTemplateId && (
          <p style={{ marginBottom: "5px", marginRight: "20px" }}>
            Rev :{revisedNo}
          </p>
        )}
        {selectedRevId.length > 0 && (
          <button
            className="delete-revision"
            onClick={() => setDeleteRevisionDial(true)}
          >
            Delete
          </button>
        )}
      </div>
      {!revisedTemplateId && (
        <table
          className={
            isNavBarOpen
              ? "estimate-rev-details-table"
              : "estimate-rev-details-table-close"
          }
        >
          <thead>
            <tr>
              <th style={{ width: "15px", textAlign: "center" }}>
                <FaChevronDown />
              </th>
              <th style={{ width: "60px" }}>Rev No</th>
              <th style={{ minWidth: "60px" }}>Date</th>
              <th style={{ minWidth: "60px" }}>Template Name</th>
              <th style={{ minWidth: "60px" }}>Estimate By</th>
              <th style={{ minWidth: "60px" }}>Revised By</th>
            </tr>
          </thead>
          <tbody>
            {revision.tasks[Template] &&
              revision.tasks[Template].map((item, index) => (
                <tr key={index}>
                  <td
                    style={{
                      alignItems: "center",
                      paddingLeft: "7px",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{ cursor: "pointer" }}
                      checked={selectedRevId.includes(item.id)}
                      onChange={(e) => handleDeleteRevision(e, item.id)}
                    />
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setRevisedTemplateId(item.id);
                      setRevisedeNo(index + 1);
                      setRevTemplateName(item.template_name);
                    }}
                  >
                    Rev {index + 1}
                  </td>
                  <td>{format(new Date(item.date), "dd-MM-yyyy  hh:mm a")}</td>
                  <td>{item.template_name}</td>
                  <td>{item.estimated_by_name}</td>
                  <td>{item.revised_by_name}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
      {revisedTemplateId && (
        <div>
          <TbArrowBackUp
            className="revise-task-close"
            style={{ top: "2rem" }}
            onClick={() => {
              setRevisedTemplateId("");
              setRevisedeNo("");
              setRevTemplateName("");
            }}
          />
          <table
            className={
              isNavBarOpen
                ? "revision-details-table"
                : "revision-details-table-close"
            }
          >
            <thead>
              <tr>
                <th style={{ width: "3px" }}>SNo</th>
                <th style={{ width: "90px" }}>Task Name</th>
                <th style={{ width: "16px" }}>Planned Hrs</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedTasks).map((code) => {
                const totalGroupHours = groupedTasks[code].reduce(
                  (sum, task) => sum + parseFloat(task.planned_hours || 0),
                  0
                );

                const formattedTotal = toHHMM(totalGroupHours);

                return (
                  <React.Fragment key={code}>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f0f0f0",
                        }}
                      >
                        {codeDescriptions[code]}
                      </td>
                      <td
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f0f0f0",
                          textAlign: "center",
                        }}
                      >
                        {formattedTotal}
                      </td>
                    </tr>
                    {groupedTasks[code].map((task, index) => (
                      <tr key={task.id}>
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td>{task.task_name}</td>
                        <td style={{ textAlign: "center" }}>
                          {task.formatted_planned_hours}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })}
              {revTemplateName === "Design" && (
                <tr>
                  <td colSpan={2}>Grand Total</td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {grandTotal}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {deleteRevisionDial && (
        <div className={`delete-phase-dial ${dialBoxopen ? "open" : "close"} `}>
          <div className="delete-dial">
            <div className="dial-d-header">
              <h3
                style={{ backgroundColor: "transparent", marginLeft: "15px" }}
              >
                Delete Phase
              </h3>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <p style={{ backgroundColor: "white" }}>
                Are you sure you want to delete this Revision? This action
                cannot be undone.
              </p>
              <input
                style={{ cursor: "pointer" }}
                type="checkbox"
                id="delete-phase"
                checked={isCheckboxChecked}
                onChange={() => setIsCheckboxChecked((prev) => !prev)}
              />
              <label
                htmlFor="delete-phase"
                style={{ backgroundColor: "white", cursor: "pointer" }}
              >
                I understand this action cannot be undone.
              </label>
            </div>
            <div className="delete-dial-btn-con">
              <button
                onClick={handleDeleteConfirm}
                color="secondary"
                variant="contained"
                disabled={!isCheckboxChecked}
                className="add-btn"
                style={{ backgroundColor: isCheckboxChecked ? "red" : "gray" }}
              >
                Delete
              </button>
              <button
                onClick={() => {
                  setSelectedRevId([], setDeleteRevisionDial(false));
                  setIsCheckboxChecked(false);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RevisionTable;
